import Loading from "../../../components/loading";
import { ChartTypeEnum } from "../../../models/chart";
import AdminManageGeneralChartForm from "./components/admin-manage-general-chart-form/admin-manage-general-chart-form";
import AdminManageGeneralChartHeader from "./components/admin-manage-general-chart-header";
import useAdminManageGeneralChart from "./hooks/use-admin-manage-general-chart";

const AdminManageGeneralChart = () => {
  const state = useAdminManageGeneralChart(ChartTypeEnum.GENERAL_ELECTION);

  return (
    <div className="min-h-screen" style={{ paddingBottom: "48px" }}>
      <AdminManageGeneralChartHeader />
      {state.loading ? (
        <Loading />
      ) : (
        <AdminManageGeneralChartForm state={state} />
      )}
    </div>
  );
};

export default AdminManageGeneralChart;
